import { Controller } from "stimulus";
import { EventCurrencyChanged } from "../events";
import { setActiveCurrency, getActiveCurrency } from "../util/currency";

export default class extends Controller {
  static targets = ["button"];

  connect() {
    window.addEventListener(EventCurrencyChanged, () => {
      this._updateButton(getActiveCurrency());
    });
  }

  _updateButton(currencyCode) {
    this.buttonTarget.innerText = currencyCode.toUpperCase();
  }

  _selectCurrency(e) {
    const currencyCode = e.currentTarget.getAttribute("data-iso-code");
    setActiveCurrency(currencyCode);

    // Dispatch currency changed event
    this.element.dispatchEvent(
      new CustomEvent(EventCurrencyChanged, {
        bubbles: true,
        cancelable: false,
        detail: {
          currencyCode: currencyCode
        }
      })
    );

    e.preventDefault();
  }
}



// WEBPACK FOOTER //
// ./app/assets/webpack/controllers/currency_dropdown_controller.js